<div class="six-digit-code">
  <input #codeInput="" name="code" class="code-input" required="" />
  <input #codeInput="" name="code" class="code-input" required="" />
  <input #codeInput="" name="code" class="code-input" required="" />
  <input #codeInput="" name="code" class="code-input" required="" />
  <input #codeInput="" name="code" class="code-input" required="" />
  <input #codeInput="" name="code" class="code-input" required="" />
</div>
